"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-martino-in-badia": {
    "334a6650": [{
      "hkey": "f9d2169f",
      "slug": "san-martin-capoluogo",
      "name": "San Martin (capoluogo)",
      "primary": true,
      "skipSearch": false
    }],
    "san-martin-capoluog": [{
      "hkey": "f9d2169f",
      "slug": "san-martin-capoluogo",
      "name": "San Martin (capoluogo)",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;